export default __webpack_public_path__ + "static/media/the-rental-cineplexbd.2150749c.jpg";